import { IsAuthenticatedContext } from "auth";
import { useContext, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { PublicPage } from "layouts";
import { LoadingPoints } from "styles/flex";
import { LOG_OUT, LogOutResponse, LogOutVars } from "pages/Login/queries";
import { useMutation } from "@apollo/client";
// import { ConfirmDialog } from "components/molecules/ConfirmDialog";

export const Logout = () => {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useContext(
    IsAuthenticatedContext
  );
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [logOut, { loading: isLoadingLogOut }] = useMutation<
    LogOutResponse,
    LogOutVars
  >(LOG_OUT);

  useEffect(() => {
    const username = localStorage.getItem("username");
    if (username === null && !username) {
      setTimeout(() => {
        window.location.reload();
        navigate("/login");
      }, 5000);
    }
    return () => {
      window.location.reload();
    };
  }, [isAuthenticated]);

  const loggingOut = async () => {
    const usernameEncoded = localStorage.getItem("username") || "";
    const usernameDecoded = atob(usernameEncoded);

    const result = await logOut({
      variables: { userId: usernameDecoded || undefined },
    });

    if (result?.data) {
      localStorage.removeItem("tabValue");
      localStorage.removeItem("username");
      localStorage.removeItem("isLoggedIn");
      localStorage.removeItem("passValid");
      localStorage.removeItem("selectedSpecialist");
      localStorage.removeItem("selectedPrograms");
      localStorage.removeItem("username");
      localStorage.removeItem("rowsPerPage");
      setIsAuthenticated(false);
    }
  };

  useEffect(() => {
    loggingOut();
  }, []);

  const LoadingDots = () => {
    return (
      <LoadingPoints>
        <span className="loading-dots" />
      </LoadingPoints>
    );
  };

  return (
    <PublicPage
      title={
        <>
          Logging you out
          <LoadingDots />
        </>
      }
    >
      <Link
        to="/login"
        style={{ textAlign: "center", width: "100%", display: "none" }}
      >
        Sign in again
      </Link>
    </PublicPage>
  );
};
